import { render, staticRenderFns } from "./ResellerConnectedUser.vue?vue&type=template&id=2ccb04d9"
import script from "./ResellerConnectedUser.vue?vue&type=script&lang=js"
export * from "./ResellerConnectedUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports